import React from "react";
// import "./TermsOfService.css"; // Ajouter un fichier CSS si nécessaire
import SEO from "../SEO/SEO";

const TermsOfService = () => {
  return (
    <div>
      <SEO
        title="Terms of Service - RS Transports"
        description="Terms of Service of RS Transports. Learn about our service conditions, booking policies, and dispute resolution."
        keywords="RS Transports, terms of service, booking policy, legal, transportation rules"
      />

      <section id="terms-of-service" className="py-5">
        <div className="container">
          <h1 className="text-center mb-4">Terms of Service</h1>

          <div className="row">
            <div className="col-md-12">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">1. Introduction</h2>
                  <p>These Terms of Service govern the use of RS Transports' airport transfer services.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">2. Booking & Payment</h2>
                  <p>All bookings must be made in advance through our website. Payment is required at the time of booking.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">3. Cancellation & Refund Policy</h2>
                  <p>Cancellations made at least 24 hours before departure are fully refundable. No refunds are given for cancellations made within 24 hours of the scheduled pick-up time.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">4. Service Conditions</h2>
                  <p>Passengers must be ready at the pick-up location at the scheduled time. We are not responsible for delays caused by traffic, weather, or force majeure events.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">5. Dispute Resolution</h2>
                  <p>In case of disputes, we encourage resolving the matter amicably. If no agreement is reached, legal disputes shall be referred to the competent courts in Paris.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">6. Contact</h2>
                  <p>If you have any questions about these Terms of Service, please contact us:</p>
                  <p>Email: <a href="mailto:contact@rstransports.com">contact@rstransports.com</a></p>
                  <p>Phone: +33 6 68 16 08 42</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
